// extracted by mini-css-extract-plugin
export default {"languageButton":"UserLanguage_languageButton__jdZZ1","languageIcon":"UserLanguage_languageIcon__sS0P3","languageText":"UserLanguage_languageText__Yl-Fq"};